const GenderGroup = {
	en: {
		male: "Male",
		female: "Female",
		any: "Any Gender"
	},
	es: {
		male: "Masculino",
		female: "Femenino",
		any: "Cualquiera"
	},
	ko: {
		male: "Gason",
		female: "Fi",
		any: "Nenpòt"
	}
};
export default GenderGroup;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/gender-group/gender-group.language.js